import template from './template.html'
import { Link } from './controller'

function directive(
  $rootScope,
  $ngRedux,
  picklistService,
  storyService,
  featureFlagService
) {
  return {
    restrict: 'AE',
    replace: false,
    template,
    controller: 'StoryController',
    link: Link(
      $rootScope,
      $ngRedux,
      picklistService,
      storyService,
      featureFlagService
    ),
  }
}

export default [
  '$rootScope',
  '$ngRedux',
  'picklistService',
  'storyService',
  'featureFlagService',
  directive,
]
